import React from 'react'

import { Dropdown, type DropdownOption } from '@/components/ui'
import { useApi } from '@/hooks'
import { type DataSource } from '@/types/data-source'

interface Params {
  label?: string
  companyId?: number
  makes?: string[]
  onChange: (makes?: string[]) => void
  placeholder?: string
  /** Which back end to list makes from; defaults to Fresh. */
  dataSource?: DataSource
}

export const AssetMakeDropdown: React.FC<Params> = ({
  makes,
  companyId,
  onChange,
  label = 'Asset Makes',
  placeholder = 'Select asset makes...',
  dataSource,
}) => {
  const { api } = useApi()
  const [options, setOptions] = React.useState<DropdownOption[]>([])

  React.useEffect(() => {
    if (!api) {
      return
    }
    if (!companyId) {
      setOptions([])
      return
    }
    const fn = async () => {
      const response = await api!.get<Array<{ id: number; make: string; model: string }>>({
        path: `/fridge-types?companyId[]=${companyId}&skip=0&take=5000${dataSource ? `&dataSource=${dataSource}` : ''}`,
        origin: 'AssetMakeDropdown',
        expiresIn: '4h',
      })
      if (response.error || !response.data) {
        console.error(response.error)
        setOptions([])
      } else {
        const makes = Array.from(new Set(response.data.map((a) => a.make)))
        setOptions(makes.map((m) => ({ label: m, value: m })))
      }
    }
    fn()
  }, [companyId])

  return (
    <div>
      <label>{label}</label>
      <Dropdown
        options={options}
        handleMultiSelectItem={(opt: DropdownOption[]) => {
          const selectedValues = opt.filter((option) => option.value !== '').map((option) => option.value)
          const newValues = selectedValues.length > 0 ? selectedValues : undefined
          onChange(newValues)
        }}
        selectedItem={options.filter((o) => Array.isArray(makes) && makes.includes(o.value))}
        placeholder={placeholder}
        isMultiSelect
        animateDots={!!(companyId && !options.length)}
      />
    </div>
  )
}
